import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  categoryId: string;
  categoryName: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readCount: number;
  commentCount: number;
  likes: number;
  tags: string[];
  isHot?: boolean;
  isPinned?: boolean;
}

export default function ArticleCard({
  id,
  title,
  excerpt,
  categoryId,
  categoryName,
  author,
  authorAvatar,
  publishDate,
  readCount,
  commentCount,
  likes,
  tags,
  isHot,
  isPinned,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-300 transition-all group">
      <div className="flex items-center gap-2 mb-2.5 flex-wrap">
        {isPinned && (
          <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
            <i className="ri-pushpin-line text-[10px]"></i>置顶
          </span>
        )}
        {isHot && (
          <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">
            <i className="ri-fire-line text-[10px]"></i>热门
          </span>
        )}
        <Link
          to={`/category/${categoryId}`}
          className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full hover:bg-secondary-200 transition-colors"
        >
          {categoryName}
        </Link>
      </div>

      <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors font-heading leading-snug">
        <Link to={`/article/${id}`} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          {title}
        </Link>
      </h3>

      <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
        {excerpt}
      </p>

      <div className="flex items-center gap-2 mb-3 flex-wrap">
        {tags.map((tag) => (
          <span key={tag} className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
            {tag}
          </span>
        ))}
      </div>

      <div className="flex items-center justify-between text-xs text-foreground-500">
        <div className="flex items-center gap-2">
          <img
            src={authorAvatar}
            alt={author}
            className="w-6 h-6 rounded-full object-cover"
            width="24"
            height="24"
          />
          <span className="text-foreground-700">{author}</span>
          <span className="text-foreground-400">·</span>
          <span>{publishDate}</span>
        </div>
        <div className="flex items-center gap-3">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line text-[11px]"></i>{readCount.toLocaleString()}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line text-[11px]"></i>{commentCount}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-heart-line text-[11px]"></i>{likes}
          </span>
        </div>
      </div>
    </article>
  );
}